import * as api from '../api';
import {
  shipmentTrackingDetailRequest,
  shipmentTrackingLineHaulRequest,
} from '../api/requestCreator';
import { setShipmentTracking } from '../analytics/gatherService';
import { ACTIONS } from '../constants';

const updateShipmentTrackingDetail = (
  dispatch: Function,
  shipmentTrackingDetail: Object,
  trackingNumber: string,
  filter: string,
  groupIndex: string
) => {
  dispatch({
    type: 'FETCH_SHIPMENT_TRACKING_DETAIL_SUCCESS',
    response: shipmentTrackingDetail,
    id: `${trackingNumber}_${groupIndex}`,
    filter,
  });
};

const getLastMileShipment = (shipments: Array) => {
  if(shipments.length < 2) return shipments[0];
  const lastMile = shipments.filter((s: Object) => s.trackingType === "LastMile");
  return lastMile ? lastMile[0] : shipments[1];
};

const fetchShipmentTrackingDetail = (
  filter: string,
  isCarrierIntegrationAvailable: boolean,
  isLineHaul: boolean,
  providerCode: string,
  shipments: Array,
  groupIndex: string
) => (dispatch: Function) => {
  // get first tracking number
  const { trackingNumber } = isLineHaul ? getLastMileShipment(shipments) : shipments[0];
  dispatch({
    type: ACTIONS.FETCH_SHIPMENT_TRACKING_DETAIL,
    id: trackingNumber,
    filter,
  });
  // integrated carrier
  if (isCarrierIntegrationAvailable) {
    // check for linehaul
    if (isLineHaul) {
      const payload = shipmentTrackingLineHaulRequest(shipments);
      const { url, data } = payload;
      api.postRequest(url, data).then(
        (response: Object) => {
          const { shipmentTrackingDetail } = response.data;
          // update store with response
          updateShipmentTrackingDetail(
            dispatch,
            shipmentTrackingDetail,
            trackingNumber,
            filter,
            groupIndex
          );
          // analytics - integrated linehaul tracking number: success
          setShipmentTracking(true, filter);
        },
        (error: Object) => {
          console.log(error);
          const nonInteratedTrackingDetail = {
            trackingNo: trackingNumber,
          };
          updateShipmentTrackingDetail(
            dispatch,
            nonInteratedTrackingDetail,
            trackingNumber,
            filter,
            groupIndex
          );
          // analytics - integrated linehaul tracking number: failure
          setShipmentTracking(false, filter);
        }
      );
    } else {
      const url = shipmentTrackingDetailRequest(providerCode, trackingNumber);
      api.getRequest(url).then(
        (response: Object) => {
          const { shipmentTrackingDetail } = response.data;
          // update store with response
          updateShipmentTrackingDetail(
            dispatch,
            shipmentTrackingDetail,
            trackingNumber,
            filter,
            groupIndex
          );
          // analytics - integrated carrier tracking number: success
          setShipmentTracking(true, filter);
        },
        (error: Object) => {
          console.log(error);
          const nonInteratedTrackingDetail = {
            trackingNo: trackingNumber,
          };
          updateShipmentTrackingDetail(
            dispatch,
            nonInteratedTrackingDetail,
            trackingNumber,
            filter,
            groupIndex
          );
          // analytics - integrated carrier tracking number: failure
          setShipmentTracking(false, filter);
        }
      );
    }
  } else {
    // non-integrated carrier
    const nonInteratedTrackingDetail = {
      trackingNo: trackingNumber,
    };
    updateShipmentTrackingDetail(
      dispatch,
      nonInteratedTrackingDetail,
      trackingNumber,
      filter,
      groupIndex
    );
    // analytics - non-integrated carrier tracking number: success
    setShipmentTracking(true, filter);
  }
};

export default fetchShipmentTrackingDetail;
